/* eslint-disable no-undef */
import { REDUX_CONSTANT } from '../../constants';
import { JSON_HEADER, AUTH_HEADER } from '../../config';
import config from '../../config.json';
import { createEndpoint } from './../../helpers/commonHelper';
import * as TYPES from '../types';

const util = require('util');

/**
 * Function handle onLoad state of API call
 *
 */
export const onLoad = () => ({
    type: TYPES.ON_LOAD,
    payload: {
        isLoading: false
    }
});

/**
 * Function handle onfail scenario
 *
 */
export const onfail = (msg, title = '') => ({
    type: TYPES.ERROR,
    payload: { msg, title }
});

/**
 * @function - name : getPaginatedVendorList, Creates endpoint URL for getVendorListData API call
 * @params : { searchText : string, sortFieldForVendorManagement : string, sortOrderForVendorManagement : string, pageNumber: integer, pageSize: integer, isVendorForDropdownValue: string }
 * @return - created endpoint with params
 */
function getPaginatedVendorList(
    searchText,
    sortFieldForVendorManagement,
    sortOrderForVendorManagement,
    pageNumber,
    pageSize,
    isVendorForDropdownValue,
    isMarketplaceFlaggedDropdownValue
) {
    let endpoint = '',
        marketplaceFlagValue = '';
    endpoint = util.format(
        config.REACT_APP_GET_VENDOR_LIST_URL,
        sortFieldForVendorManagement,
        sortOrderForVendorManagement,
        pageNumber,
        pageSize
    );

    if (searchText && searchText.length > 0) {
        endpoint = endpoint + `&SearchText=${searchText}`;
    }
    if (isVendorForDropdownValue && isVendorForDropdownValue !== 'All') {
        endpoint = endpoint + `&VendorType=${isVendorForDropdownValue}`;
    }
    if (
        isMarketplaceFlaggedDropdownValue &&
        isMarketplaceFlaggedDropdownValue !== 'All'
    ) {
        marketplaceFlagValue = isMarketplaceFlaggedDropdownValue === 'Enabled';
        endpoint = endpoint + `&IsPublic=${marketplaceFlagValue}`;
    }
    return endpoint;
}

/**
 * Function call getVendorListData API
 *
 * @param - searchText - type (string)
 * @param - sortFieldForVendorManagement - type (string)
 * @param - sortOrderForVendorManagement - type (string)
 * @param - pageNumber - type (integer)
 * @param - pageSize - type (integer)
 * @param - isVendorForDropdownValue - type (string)
 *
 */
export const getVendorListData = (
    SearchText,
    sortFieldForVendorManagement,
    sortOrderForVendorManagement,
    PageNumber,
    PageSize,
    isVendorForDropdownValue,
    isMarketplaceFlaggedDropdownValue
) => {
    let endPoint = `${createEndpoint(
        REDUX_CONSTANT.services.configurationService
    )}${getPaginatedVendorList(
        SearchText,
        sortFieldForVendorManagement,
        sortOrderForVendorManagement,
        PageNumber,
        PageSize,
        isVendorForDropdownValue,
        isMarketplaceFlaggedDropdownValue
    )}`;
    return {
        type: TYPES.APIREQUEST,
        payload: {
            onload: onLoad,
            endpoint: endPoint,
            method: 'GET',
            onsuccess: getVendorListDataSuccess,
            onerror: onfail,
            title: REDUX_CONSTANT.GET_VENDOR_MANAGEMENT_DATA
        }
    };
};

/**
 * Function handle onsuccess scenario of getVendorListData
 *
 */
export const getVendorListDataSuccess = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.GET_VENDOR_MANAGEMENT_DATA
    };
};

/**
 * Function call getAllProducts API
 *
 */
export const getAllProducts = () => ({
    type: TYPES.APIREQUEST,
    payload: {
        onload: onLoad,
        endpoint: `${createEndpoint(
            REDUX_CONSTANT.services.configurationService
        )}${util.format(config.REACT_APP_GET_ALL_PRODUCTS_URL)}`,
        method: 'GET',
        onsuccess: onGetAllProductsSuccess,
        onerror: onfail
    }
});

/**
 * Function handle onsuccess scenario of getAllProducts
 *
 */
export const onGetAllProductsSuccess = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.GET_ALL_PRODUCTS_DATA
    };
};

/**
 * Function call createNewVendor API
 *
 * @param - body - type (Object)
 *
 */
export const createNewVendor = (body, updateVendor) => {
    return {
        type: TYPES.APIREQUEST,
        payload: {
            onload: onLoad,
            endpoint: `${createEndpoint(
                REDUX_CONSTANT.services.configurationService
            )}${util.format(config.REACT_APP_CREATE_NEW_VENDOR_URL)}`,
            method: updateVendor ? 'PATCH' : 'POST',
            body: JSON.stringify(body),
            onsuccess: createNewVendorSuccess,
            onerror: onfail,
            title: REDUX_CONSTANT.CREATE_NEW_VENDOR_DATA
        }
    };
};

/**
 * Function handle onsuccess scenario of createNewVendor
 *
 */
export const createNewVendorSuccess = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.CREATE_NEW_VENDOR_DATA
    };
};

/**
 * Function call Vendor Client Secret Data (Integration or Production)
 *
 * @param - token - type (string)
 * @param - vendorId - type (string)
 * @param - clientId - type (string)
 * @param - isIntegration - type (boolean) - flag to differentiate between integration and production
 */
export const getClientSecretData = (
    token,
    vendorId,
    clientId,
    pageNumber,
    pageSize,
    isIntegration = false
) => ({
    type: TYPES.APIREQUEST,
    payload: {
        onload: onLoad,
        endpoint: `${createEndpoint(
            REDUX_CONSTANT.services.configurationService
        )}${util.format(
            config.REACT_APP_CLIENT_SECRET_DATA_URL,
            vendorId,
            clientId,
            pageNumber,
            pageSize
        )}`,
        method: 'GET',
        headers: Object.assign({}, JSON_HEADER, AUTH_HEADER(token)),
        onsuccess: isIntegration
            ? getClientSecretIntegrationDataSuccess
            : getClientSecretProductionDataSuccess,
        onerror: onfail,
        title: isIntegration
            ? REDUX_CONSTANT.GET_CLIENT_SECRET_INTEGRATION_DATA
            : REDUX_CONSTANT.GET_CLIENT_SECRET_PRODUCTION_DATA
    }
});

/**
 * Function handle onsuccess scenario of getClientSecretIntegrationData
 *
 */
export const getClientSecretIntegrationDataSuccess = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.GET_CLIENT_SECRET_INTEGRATION_DATA
    };
};

/**
 * Function handle onsuccess scenario of getClientSecretProductionData
 *
 */
export const getClientSecretProductionDataSuccess = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.GET_CLIENT_SECRET_PRODUCTION_DATA
    };
};

/**
 * Function call DeleteClientSecret API
 *
 * @param - vendorId - type (string)
 * @param - clientId - type (string)
 * @param - secretId - type (string)
 * @param - token - type (string)
 *
 */
export const deleteClientSecret = (
    vendorId,
    clientId,
    secretId,
    token,
    username
) => {
    let body = {
        deletedBy: username
    };
    return {
        type: TYPES.APIREQUEST,
        payload: {
            onload: onLoad,
            endpoint: `${createEndpoint(
                REDUX_CONSTANT.services.configurationService
            )}${util.format(
                config.REACT_APP_DELETE_CLIENT_SECRET_DATA_URL,
                vendorId,
                clientId,
                secretId
            )}`,
            body: JSON.stringify(body),
            method: 'PATCH',
            headers: Object.assign({}, JSON_HEADER, AUTH_HEADER(token)),
            onsuccess: deleteClientSecretSuccess,
            onerror: onfail,
            title: REDUX_CONSTANT.DELETE_CLIENT_SECRET_DATA
        }
    };
};

/**
 * Function handle onsuccess scenario of deleteClientSecret
 *
 */
export const deleteClientSecretSuccess = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.DELETE_CLIENT_SECRET_DATA
    };
};

/**
 * Function call AddClientSecret API (Integration or Production)
 *
 * @param - vendorId - type (string)
 * @param - clientId - type (string)
 * @param - clientSecretBody - type (object)
 * @param - token - type (string)
 * @param - isIntegration - type (boolean) - flag to differentiate between integration and production
 *
 */
export const addClientSecret = (
    vendorId,
    clientId,
    clientSecretBody,
    token,
    isIntegration = false
) => {
    return {
        type: TYPES.APIREQUEST,
        payload: {
            onload: onLoad,
            endpoint: `${createEndpoint(
                REDUX_CONSTANT.services.configurationService
            )}${util.format(
                config.REACT_APP_CLIENT_SECRET_DATA_URL,
                vendorId,
                clientId
            )}`,
            method: 'POST',
            headers: Object.assign({}, JSON_HEADER, AUTH_HEADER(token)),
            body: JSON.stringify(clientSecretBody),
            onsuccess: isIntegration
                ? addClientIntegrationSecretSuccess
                : addClientProductionSecretSuccess,
            onerror: onfail,
            title: isIntegration
                ? REDUX_CONSTANT.ADD_CLIENT_SECRET_INTEGRATION_DATA
                : REDUX_CONSTANT.ADD_CLIENT_SECRET_PRODUCTION_DATA
        }
    };
};

/**
 * Function handle onsuccess scenario of AddClientIntegrationSecret
 *
 */
export const addClientIntegrationSecretSuccess = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.ADD_CLIENT_SECRET_INTEGRATION_DATA
    };
};

/**
 * Function handle onsuccess scenario of AddClientProductionSecret
 *
 */
export const addClientProductionSecretSuccess = (payload) => {
    return {
        payload,
        type: REDUX_CONSTANT.ADD_CLIENT_SECRET_PRODUCTION_DATA
    };
};

/**
 * Function to change the state of loader
 * @param - value - boolean
 */
export const updateIsLoading = (value) => {
    return {
        payload: value,
        type: REDUX_CONSTANT.ISLOADING
    };
};

export const clearClientSecretResponses = () => {
    return {
        type: REDUX_CONSTANT.CLEAR_CLIENT_SECRET_RESPONSES
    };
};

export const removeClientSecretFromState = (
    secretId,
    isIntegration = false
) => {
    return {
        type: REDUX_CONSTANT.REMOVE_CLIENT_SECRET_FROM_STATE,
        payload: {
            secretId,
            isIntegration
        }
    };
};
